import { FLAGS } from '@iheartjane/feature-flags';
import { CompareProducts } from '@iheartjane/menu';

import { useRootLoaderData } from '@jane/bloom/hooks/useRootLoaderData';

interface CompareIntroProps {
  isMobile: boolean;
}

/** Waits for the age gate so it never stacks on it. */
export const CompareIntro = ({ isMobile }: CompareIntroProps) => {
  const { ageGate, featureFlags } = useRootLoaderData();

  return (
    <CompareProducts.Intro
      enabled={
        Boolean(featureFlags[FLAGS.c2CompareIntro]) &&
        Boolean(ageGate?.confirmedAge)
      }
      isMobile={isMobile}
    />
  );
};
